import React, { useEffect } from 'react'

//components
import Navbar from '../components/Navbar/Navbar'
import Banner from '../components/Banner/LoanBanner'
import AccountInfo from '../components/CustomerInformation/AccountInfo'
import Footer from '../components/Footer/Footer'
  
const CustomerInfo = () => {
    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'auto'})
    }, []);

    return (
        <>
            <Navbar /> 
            <Banner /> 
            <AccountInfo />
            <Footer />
        </>
    )
}

export default CustomerInfo
